<template>
  <div class="form-group">
    <label :for="computedName">
      {{ label }}
      <validation-message
        :required="required"
        :invalid="invalid"
        :for="computedName"
        :errorMessage="errorMessage"
      />
    </label>

    <select
      :title="computedName"
      :name="computedName"
      :id="computedName"
      class="form-input"
      v-model="internalValue"
      :disabled="disabled ? 'disabled' : null"
      :required="required"
      @click="$emit('click', $event)"
      @keydown.down="$emit('keydown', $event)"
      @keydown.up="$emit('keydown', $event)"
      @change="$emit('change', $event)"
    >
      <option value disabled selected v-if="placeholder">
        {{ placeholder }}
      </option>
      <option value selected v-if="optionLabel">
        {{ optionLabel }}
      </option>
      <option value v-else-if="hasBlankOption && options.length > 1"></option>
      <option
        v-for="(item, index) in options"
        :key="index"
        :disabled="item.disabled"
        :value="valueWholeOption ? item : item.value"
        :selected="options.length === 1"
      >
        <template v-if="valueWholeOption">
          {{ item[valueKey] }}
        </template>
        <template v-else>
          {{ item.text }}
        </template>
      </option>
    </select>
  </div>
</template>
<script>
  import ValueInputBindings from '@mixins/ValueInputBindings'
  import ValidationMessage from '@atoms/ValidationMessage'

  export default {
    mixins: [ValueInputBindings],
    components: { ValidationMessage },
    props: {
      label: String,
      name: String,
      value: [String, Number, Object],
      options: Array,
      optionLabel: String,
      disabled: Boolean,
      valueWholeOption: {
        type: Boolean,
        default: false
      },
      valueKey: String,
      placeholder: String,
      required: {
        type: Boolean,
        default: false
      },
      invalid: {
        type: Boolean,
        default: false
      },
      hasBlankOption: {
        type: Boolean,
        default: true
      },
      errorMessage: {
        type: String,
        default: ''
      },
      allowValueOutsideOptions: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      computedName() {
        return this.name || this.valueKey
      }
    },
    created() {
      if (this.options.length === 1) {
        const firstOptionValue = this.options[0].value
        this.internalValue = firstOptionValue

        // make sure we let the parent components know this value has changed, some compontents
        // wait for the first @change event to emit their own payloads (eg: ReportingCodes)
        this.$emit('input', firstOptionValue)
      }
    },
    watch: {
      options(options) {
        // sometimes options can come in after the page is created, eg: external users adding a
        // new subscriber, the class and plan come in from a query after the /classplan endpoint
        if (options.length === 1) {
          const firstOptionValue = options[0].value
          this.internalValue = firstOptionValue
          this.$emit('input', firstOptionValue)
        } else {
          // select was retaining the old value it was holding even if there are no options with that value anymore
          // after an options update
          if (this.allowValueOutsideOptions) return
          const verifyOptionsWithValueExists = options.find(
            opt => opt.value == this.internalValue
          )
          if (!verifyOptionsWithValueExists && this.internalValue) {
            this.internalValue = ''
            this.$emit('input', '')
          }
        }
      }
    }
  }
</script>
